module.exports = __webpack_public_path__ + "img/zhengchang.0f24e14e.png";